import * as React from 'react';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import * as BaseFieldStyles from '../Field.scss';
import { BaseText } from '../baseText/BaseTextField';
import { Fragment } from '../../../utilities/components/Fragment';

export interface IUserFieldPerson {
  personKey: string;
  title: string;
  email: string;
  picture: string;
  sip: string;
  ariaLabel?: string;
  displayValue?: string;
}
export interface IUserHoverCardProp {
  personKey: string;
  displayValue?: string;
}
export interface IUserFieldProps {
  users: Array<IUserFieldPerson>;
  isDisabled?: boolean;
  userHoverCard?: React.ComponentType<IUserHoverCardProp>;
}

const getSingleUserRenderer =
  (userFieldProps: IUserFieldProps, index: number) => {
    const user = userFieldProps.users[index];
    const UserHoverCard = userFieldProps.userHoverCard;
    const isDisabled = userFieldProps.isDisabled;

    return (
      UserHoverCard ? (
        <UserHoverCard personKey={ user.personKey } displayValue= { user.displayValue || ''} key={ index }>
          <BaseText
            isDisabled={ isDisabled }
            className={ css(`${BaseFieldStyles.field}`, `${BaseFieldStyles.nofill}`) }
            text={ user.displayValue || user.title }
          />
        </ UserHoverCard>
      ) : (
          <BaseText
            isDisabled={ isDisabled }
            className={ css(`${BaseFieldStyles.field}`, `${BaseFieldStyles.nofill}`) }
            text={ user.displayValue || user.title }
          />
        )
    );
  };

export const UserFieldWithHoverCard: React.StatelessComponent<IUserFieldProps> = (props: IUserFieldProps) => {
  const { users } = props;

  if (!users || !users.length) {
    return null; // save dom elements for empty column
  }

  return (
    users.length === 1 ? (
      getSingleUserRenderer(props, 0)
    ) :
      (
        <Fragment>
          { users.map((user: IUserFieldPerson, index: number) => (
            getSingleUserRenderer(props, index)
          )) }
        </Fragment>
      )
  );
};
